import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { onMessage } from 'firebase/messaging';
import { getFirebaseMessaging } from '@/firebase/config';
import { GetAlarmListResponse } from '@/api/type/commonTypes';
import { toast } from '@/stores/slices/notification/toastSlice';

export const useFcmForegroundListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;

    const setupListener = async () => {
      const messaging = await getFirebaseMessaging();
      console.log('messaging', messaging);
      if (!messaging) return;
      unsubscribe = onMessage(messaging, (payload) => {
        const category = payload.data?.category;
        console.log('payload', payload);
        if (category !== 'ALARM') return;

        const alarmRaw = payload.data?.alarm;
        if (!alarmRaw) return;

        try {
          const alarmItem = JSON.parse(alarmRaw) as GetAlarmListResponse;
          dispatch(toast.addToast(alarmItem));
        } catch (error) {
          console.error('알림 데이터 파싱 실패:', error);
        }
      });
    };

    setupListener();
    return () => unsubscribe?.();
  }, [dispatch]);
};
